// eslint-disable-next-line jira/filename-case
import React from 'react';
import { SpaStateResetPage } from '@atlassian/jira-spa-state-controller/src/components/reset-page/index.tsx';
import type { LegacyPageProps } from './types.tsx';

// FIXME: SpaStateResetPage should be brought into here
// we can't only because doing so fails the legacy SSR build due to null-loader shenanigans
// probably need to pull this out to its own package (really this "common" package is only ever used for one of its components so it's a barrel - not ideal)
export const LegacyPage = (props: LegacyPageProps): React.JSX.Element => (
	<>
		<SpaStateResetPage
			match={props.match}
			action={props.action}
			route={props.route}
			isSpa={false}
		/>
	</>
);

export default LegacyPage;
